export default __webpack_public_path__ + "static/media/logo_login.06a8bf41.png";